import { useCallback, useEffect, useState } from 'react'

import { DRAFT_CHANGED_EVENT, DraftData } from './useDraft'

export interface DraftEntry<T> {
  key: string
  idPart: string
  draft: DraftData<T>
}

export function useAllDrafts<T>(prefix: string) {
  const readAll = useCallback((): DraftEntry<T>[] => {
    const result: DraftEntry<T>[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key.startsWith(prefix)) {
        try {
          const raw = localStorage.getItem(key)
          if (raw) {
            const draft = JSON.parse(raw) as DraftData<T>
            result.push({ key, idPart: key.slice(prefix.length), draft })
          }
        } catch {
          // skip corrupted entries
        }
      }
    }
    return result
  }, [prefix])

  const [entries, setEntries] = useState<DraftEntry<T>[]>(readAll)

  useEffect(() => {
    const handler = () => setEntries(readAll())
    window.addEventListener(DRAFT_CHANGED_EVENT, handler)
    return () => window.removeEventListener(DRAFT_CHANGED_EVENT, handler)
  }, [readAll])

  const deleteDraft = useCallback(
    (key: string) => {
      localStorage.removeItem(key)
      window.dispatchEvent(new CustomEvent(DRAFT_CHANGED_EVENT))
    },
    [],
  )

  return { entries, deleteDraft }
}
